import React from 'react'
import { Tag, ButtonIcon } from '@arvoreeducacao/bonsai-ds'
import {
  BookInfoContent,
  BookCoverFooter,
  Author,
  Title,
  TagWrapper,
  TagsContainer
} from './BookInfo.styles'
import type { BookInfoProps } from './BookInfo.types'
import ReactTooltip from 'react-tooltip'
import { createPortal } from 'react-dom'
import { useUserInfo } from 'utils/hooks/use-userInfo'
import useA11yEnabled from 'utils/hooks/use-a11y-enabled'
import { useTranslation } from 'i18n'

const BookInfoDesktop = ({
  title,
  author,
  degreesRange,
  moreActionsEvent,
  setIsOpen,
  contentType
}: Pick<
  BookInfoProps,
  | 'title'
  | 'author'
  | 'degreesRange'
  | 'setIsOpen'
  | 'moreActionsEvent'
  | 'contentType'
>) => {
  const degressRangeLimitedToTwo = degreesRange?.slice(0, 2)
  const { user } = useUserInfo()
  const { a11yEnabled } = useA11yEnabled()
  const { t } = useTranslation()
  const contentTypeLabel =
    contentType === 'video'
      ? t('Vídeo')
      : contentType === 'podcast'
      ? t('Podcast')
      : null
  const showTags =
    (degressRangeLimitedToTwo?.length || contentTypeLabel) &&
    !user?.isContextNonEducational

  return (
    <>
      <BookInfoContent>
        <Title>{title}</Title>
        <Author a11yEnabled={a11yEnabled}>{author}</Author>
      </BookInfoContent>
      <BookCoverFooter>
        {showTags && (
          <TagsContainer>
            {contentTypeLabel && (
              <TagWrapper>
                <Tag>{contentTypeLabel}</Tag>
              </TagWrapper>
            )}
            {degressRangeLimitedToTwo?.map((degree, index) => {
              const tooltipId = `tooltip-${index}-${encodeURI(title)}`

              return (
                <TagWrapper
                  key={degree.fullName}
                  data-tip={degree.fullName}
                  data-effect={'solid'}
                  data-for={tooltipId}
                  onFocus={event => ReactTooltip.show(event.currentTarget)}
                  onBlur={() => ReactTooltip.hide()}
                >
                  <Tag>{degree.tagName}</Tag>
                  <>
                    {createPortal(
                      <ReactTooltip id={tooltipId} />,
                      document.getElementById('modal')
                    )}
                  </>
                </TagWrapper>
              )
            })}
          </TagsContainer>
        )}
        <ButtonIcon
          iconName={'ellipsis-vertical'}
          aria-label={t('Mais opções')}
          theme={{
            type: 'ghost',
            size: 'medium'
          }}
          onClick={e => {
            e.stopPropagation()
            moreActionsEvent && moreActionsEvent()
            setIsOpen(true)
          }}
        />
      </BookCoverFooter>
    </>
  )
}

export default BookInfoDesktop
